import { Component, computed, effect, input, signal } from '@angular/core'
import {
  SpritePositionService,
  SpriteIconData,
} from 'src/app/core/services/sprite-position.service'

@Component({
  selector: 'app-sprite-image',
  templateUrl: './sprite-image.component.html',
  standalone: false,
})
export class SpriteImageComponent {
  readonly iconName = input.required<string>()
  readonly type = input<'small' | 'medium' | 'large'>('large')
  readonly spriteData = signal<SpriteIconData | null>(null)
  readonly spriteStyles = computed(() => {
    const spriteData = this.spriteData()
    if (!spriteData) return {}

    return {
      'background-image': `url('${spriteData.spriteUrl}')`,
      'background-position': `${-spriteData.x}px ${-spriteData.y}px`,
      'background-repeat': 'no-repeat',
      width: `${spriteData.width}px`,
      height: `${spriteData.height}px`,
      display: 'block',
      margin: '0 auto',
      overflow: 'hidden',
    }
  })

  constructor(private readonly spritePositionService: SpritePositionService) {
    effect((onCleanup) => {
      const iconName = this.iconName()
      const type = this.type()
      let requestIsCurrent = true

      this.spriteData.set(null)
      this.spritePositionService
        .getSpritePosition(iconName, type)
        .then((spriteData) => {
          if (requestIsCurrent) this.spriteData.set(spriteData)
        })
        .catch((error: unknown) => {
          if (requestIsCurrent) {
            console.warn(`Failed to load sprite icon ${iconName}:`, error)
          }
        })

      onCleanup(() => {
        requestIsCurrent = false
      })
    })
  }

  /**
   * Handle fallback image error
   */
  onFallbackError(): void {
    console.warn(`Failed to load fallback image for ${this.iconName()}`)
  }

  /**
   * Get actual dimensions for external use
   */
  getActualDimensions(): { width: number; height: number } | null {
    const spriteData = this.spriteData()
    if (spriteData) {
      return {
        width: spriteData.width,
        height: spriteData.height,
      }
    }
    return null
  }
}
